import React from 'react';

import BrRevisionHistoryTable from 'views/RevisionHistory/Br/BrRevisionHistoryTable';
import GenericModal from 'views/Modals/GenericRevisionHistoryModal';

const BrRevisionHistoryModal = ({ techId }: { techId: string }) => {
  const content = <BrRevisionHistoryTable techId={techId} />;

  return <GenericModal content={content} />;
};

export default BrRevisionHistoryModal;
